export default __webpack_public_path__ + "static/media/u1.0c30f482.png";